import {HomeMatchFloorsPreference} from "../constants/preferences/home_match_preferences_values";

const HOME_MATCH_FLOORS_PREFERENCE_VALUES = new Set<string>(Object.values(HomeMatchFloorsPreference));

const parseHomeMatchFloorsPreference = (value: string | null | undefined): HomeMatchFloorsPreference | null => {
    if (!value || !HOME_MATCH_FLOORS_PREFERENCE_VALUES.has(value)) return null;

    return value as HomeMatchFloorsPreference;
};

const HOME_MATCH_FLOOR_NUMBERS: Record<HomeMatchFloorsPreference, readonly number[]> = {
    [HomeMatchFloorsPreference.GROUND]: [0],
    [HomeMatchFloorsPreference.WITHOUT_GROUND]: [1, 2, 3, 4, 5, 6],
    [HomeMatchFloorsPreference.LOW]: [1, 2, 3, 4],
    [HomeMatchFloorsPreference.HIGH]: [5, 6],
    [HomeMatchFloorsPreference.TOP]: [6],
    [HomeMatchFloorsPreference.WITHOUT_TOP]: [0, 1, 2, 3, 4, 5]
};

const OPPOSITE_HOME_MATCH_FLOOR: Partial<Record<HomeMatchFloorsPreference, HomeMatchFloorsPreference>> = {
    [HomeMatchFloorsPreference.GROUND]: HomeMatchFloorsPreference.WITHOUT_GROUND,
    [HomeMatchFloorsPreference.WITHOUT_GROUND]: HomeMatchFloorsPreference.GROUND,
    [HomeMatchFloorsPreference.TOP]: HomeMatchFloorsPreference.WITHOUT_TOP,
    [HomeMatchFloorsPreference.WITHOUT_TOP]: HomeMatchFloorsPreference.TOP
};

export const toggleHomeMatchFloorsPreference = (selected: readonly HomeMatchFloorsPreference[], value: HomeMatchFloorsPreference) => {
    if (selected.includes(value)) return selected.filter((floor) => floor !== value);

    const opposite = OPPOSITE_HOME_MATCH_FLOOR[value];

    return [...selected.filter((floor) => floor !== opposite), value];
};

const HOME_MATCH_SPECIFIC_FLOOR_ORDER = [
    HomeMatchFloorsPreference.GROUND,
    HomeMatchFloorsPreference.LOW,
    HomeMatchFloorsPreference.HIGH,
    HomeMatchFloorsPreference.TOP
] as const;

const HOME_MATCH_FLOORS_PREFERENCE_ORDER = [
    ...HOME_MATCH_SPECIFIC_FLOOR_ORDER,
    HomeMatchFloorsPreference.WITHOUT_GROUND,
    HomeMatchFloorsPreference.WITHOUT_TOP
] as const;

const sameFloorNumbers = (left: readonly number[], right: readonly number[]) =>
    left.length === right.length && left.every((floor, index) => floor === right[index]);

export const toHomeMatchFloorNumbers = (preferences: readonly HomeMatchFloorsPreference[]) => {
    const floors = new Set<number>();

    for (const preference of preferences) {
        for (const floor of HOME_MATCH_FLOOR_NUMBERS[preference]) floors.add(floor);
    }

    return [...floors].sort((left, right) => left - right);
};

// `best` is assigned inside `visit`, which TypeScript does not follow: without the declared type the result is inferred as plain `null`.
const matchFloorPreferenceOrder = (target: readonly number[], order: readonly HomeMatchFloorsPreference[]): HomeMatchFloorsPreference[] | null => {
    let best: HomeMatchFloorsPreference[] | null = null;

    const visit = (start: number, chosen: HomeMatchFloorsPreference[], union: number[]) => {
        if (best && chosen.length >= best.length) return;

        if (sameFloorNumbers(union, target)) {
            best = [...chosen];
            return;
        }

        for (let index = start; index < order.length; index += 1) {
            const preference = order[index];
            const opposite = OPPOSITE_HOME_MATCH_FLOOR[preference];

            if (opposite && chosen.includes(opposite)) continue;

            const nextUnion = toHomeMatchFloorNumbers([...chosen, preference]);

            if (nextUnion.length === union.length || nextUnion.some((floor) => !target.includes(floor))) continue;

            chosen.push(preference);
            visit(index + 1, chosen, nextUnion);
            chosen.pop();
        }
    };

    visit(0, [], []);

    return best;
};

const matchHomeMatchFloorsPreferences = (floorNumbers: readonly number[] | null | undefined): HomeMatchFloorsPreference[] => {
    const target = [...new Set(floorNumbers ?? [])].sort((left, right) => left - right);

    if (!target.length) return [];

    return matchFloorPreferenceOrder(target, HOME_MATCH_SPECIFIC_FLOOR_ORDER) ?? matchFloorPreferenceOrder(target, HOME_MATCH_FLOORS_PREFERENCE_ORDER) ?? [];
};

export const getHomeMatchFloorsPreferences = (
    survey: {floor_numbers?: number[] | null; floors_preference?: string | null} | null | undefined
): HomeMatchFloorsPreference[] => {
    const preference = parseHomeMatchFloorsPreference(survey?.floors_preference);

    if (preference) return [preference];

    return matchHomeMatchFloorsPreferences(survey?.floor_numbers);
};
import {HomeMatchFloorsPreference} from "../constants/preferences/home_match_preferences_values";

const HOME_MATCH_FLOORS_PREFERENCE_VALUES = new Set<string>(Object.values(HomeMatchFloorsPreference));

const parseHomeMatchFloorsPreference = (value: string | null | undefined): HomeMatchFloorsPreference | null => {
    if (!value || !HOME_MATCH_FLOORS_PREFERENCE_VALUES.has(value)) return null;

    return value as HomeMatchFloorsPreference;
};

const HOME_MATCH_FLOOR_NUMBERS: Record<HomeMatchFloorsPreference, readonly number[]> = {
    [HomeMatchFloorsPreference.GROUND]: [0],
    [HomeMatchFloorsPreference.WITHOUT_GROUND]: [1, 2, 3, 4, 5, 6],
    [HomeMatchFloorsPreference.LOW]: [1, 2, 3, 4],
    [HomeMatchFloorsPreference.HIGH]: [5, 6],
    [HomeMatchFloorsPreference.TOP]: [6],
    [HomeMatchFloorsPreference.WITHOUT_TOP]: [0, 1, 2, 3, 4, 5]
};

const OPPOSITE_HOME_MATCH_FLOOR: Partial<Record<HomeMatchFloorsPreference, HomeMatchFloorsPreference>> = {
    [HomeMatchFloorsPreference.GROUND]: HomeMatchFloorsPreference.WITHOUT_GROUND,
    [HomeMatchFloorsPreference.WITHOUT_GROUND]: HomeMatchFloorsPreference.GROUND,
    [HomeMatchFloorsPreference.TOP]: HomeMatchFloorsPreference.WITHOUT_TOP,
    [HomeMatchFloorsPreference.WITHOUT_TOP]: HomeMatchFloorsPreference.TOP
};

export const toggleHomeMatchFloorsPreference = (selected: readonly HomeMatchFloorsPreference[], value: HomeMatchFloorsPreference) => {
    if (selected.includes(value)) return selected.filter((floor) => floor !== value);

    const opposite = OPPOSITE_HOME_MATCH_FLOOR[value];

    return [...selected.filter((floor) => floor !== opposite), value];
};

const HOME_MATCH_SPECIFIC_FLOOR_ORDER = [
    HomeMatchFloorsPreference.GROUND,
    HomeMatchFloorsPreference.LOW,
    HomeMatchFloorsPreference.HIGH,
    HomeMatchFloorsPreference.TOP
] as const;

const HOME_MATCH_FLOORS_PREFERENCE_ORDER = [
    ...HOME_MATCH_SPECIFIC_FLOOR_ORDER,
    HomeMatchFloorsPreference.WITHOUT_GROUND,
    HomeMatchFloorsPreference.WITHOUT_TOP
] as const;

const sameFloorNumbers = (left: readonly number[], right: readonly number[]) =>
    left.length === right.length && left.every((floor, index) => floor === right[index]);

export const toHomeMatchFloorNumbers = (preferences: readonly HomeMatchFloorsPreference[]) => {
    const floors = new Set<number>();

    for (const preference of preferences) {
        for (const floor of HOME_MATCH_FLOOR_NUMBERS[preference]) floors.add(floor);
    }

    return [...floors].sort((left, right) => left - right);
};

// `best` is assigned inside `visit`, which TypeScript does not follow: without the declared type the result is inferred as plain `null`.
const matchFloorPreferenceOrder = (target: readonly number[], order: readonly HomeMatchFloorsPreference[]): HomeMatchFloorsPreference[] | null => {
    let best: HomeMatchFloorsPreference[] | null = null;

    const visit = (start: number, chosen: HomeMatchFloorsPreference[], union: number[]) => {
        if (best && chosen.length >= best.length) return;

        if (sameFloorNumbers(union, target)) {
            best = [...chosen];
            return;
        }

        for (let index = start; index < order.length; index += 1) {
            const preference = order[index];
            const opposite = OPPOSITE_HOME_MATCH_FLOOR[preference];

            if (opposite && chosen.includes(opposite)) continue;

            const nextUnion = toHomeMatchFloorNumbers([...chosen, preference]);

            if (nextUnion.length === union.length || nextUnion.some((floor) => !target.includes(floor))) continue;

            chosen.push(preference);
            visit(index + 1, chosen, nextUnion);
            chosen.pop();
        }
    };

    visit(0, [], []);

    return best;
};

const matchHomeMatchFloorsPreferences = (floorNumbers: readonly number[] | null | undefined): HomeMatchFloorsPreference[] => {
    const target = [...new Set(floorNumbers ?? [])].sort((left, right) => left - right);

    if (!target.length) return [];

    return matchFloorPreferenceOrder(target, HOME_MATCH_SPECIFIC_FLOOR_ORDER) ?? matchFloorPreferenceOrder(target, HOME_MATCH_FLOORS_PREFERENCE_ORDER) ?? [];
};

export const getHomeMatchFloorsPreferences = (
    survey: {floor_numbers?: number[] | null; floors_preference?: string | null} | null | undefined
): HomeMatchFloorsPreference[] => {
    const preference = parseHomeMatchFloorsPreference(survey?.floors_preference);

    if (preference) return [preference];

    return matchHomeMatchFloorsPreferences(survey?.floor_numbers);
};
